import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';
import Mask from './SettingBarMask';
import Time from './GAConditionSetting/Time';
import Condition from './GAConditionSetting/Condition';
import TriggerTypeComponent from './GAConditionSetting/TriggerType';
import { GATriggerType } from '../../app/types';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
  },
  {
    name: 'GAConditionSetting',
  },
);

const GAConditionSetting = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerType } = selectedNode?.data;

  return (
    <>
      <div className={classes.top}>{t('add-GAConditions')}</div>
      <div id="condition-setting-bar-bottom" className={classes.bottom}>
        <TriggerTypeComponent />
        {triggerType !== GATriggerType.GAVIEW ? <Time /> : <Condition />}
      </div>
      <Mask mainId="condition-setting-bar-bottom" />
    </>
  );
};

export default GAConditionSetting;
